// removed by extract-text-webpack-plugin
module.exports = {"ClientInfo":"ClientInfo__ClientInfo__2OtAA","clientName":"ClientInfo__clientName__3e_hh","clientBirthDate":"ClientInfo__clientBirthDate__2xzBO","clientState":"ClientInfo__clientState__3w6uc","firstName":"ClientInfo__firstName__1kket","lastName":"ClientInfo__lastName__1CAFS","invalid":"ClientInfo__invalid__1e7B4","smallText":"ClientInfo__smallText__2mxBn","requiredFieldsMsg":"ClientInfo__requiredFieldsMsg__LXVM5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ClientInfo/ClientInfo.css
// module id = 487
// module chunks = 0